import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";

import { countries } from "../../../constants/countries";

export default function CountrySelect(props: {
  formik: any;
  label: string;
  error: any;
  sx?: SxProps;
}) {
  const { t } = useTranslation();
  return (
    <Autocomplete
      id="country-select"
      sx={{ width: "100%", ...props.sx }}
      options={countries}
      onChange={(e: any, value) =>
        props.formik.setFieldValue(props.label, value ? `+${value.phone}` : "")
      }
      autoHighlight
      getOptionLabel={(option) => `+${option.phone}`}
      renderOption={(optProps, option) => {
        const { key, ...rest } = optProps;
        return (
          <Box
            key={`${key}-${option.label}`}
            component="li"
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...rest}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt=""
            />
            +{option.phone}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t("common.areaCode")}
          error={Boolean(props.error)}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: "new-password",
            },
          }}
        />
      )}
    />
  );
}
